import { Button, Checkbox, Drawer, FormControlLabel, Grid, Tooltip, Typography, withStyles } from '@material-ui/core';
import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import { Help as HelpIcon } from '@material-ui/icons';
import * as aux from '../../../../auxilaries';
import { RequestTypes } from '../../../../Enums';
import { EmployeeDashboardMobileSidePanelStyles } from '../../../../styles/mobileStyles';
import { updateLoading, updateProposalPartialDates, updateSnackbar } from '../../../actions';
import { updateProposalShiftsSelected } from '../../../actions/mobileActions';
import ListSelect from '../../../components/ListSelect/ListSelect';
import { getMyShiftsToPropose } from '../../Utils/dotNet';
import { handleChangeProposalPartial } from '../../Utils/PartialShiftHelper';

class ShiftsPicker extends Component {

    constructor(props) {
        super(props)
        this.state = {
            validProposalShifts: [],
            isSkipValidation: false,
            isDrawerOpen: false,
        }
    }

    componentDidMount = async () => {
        const { formData, options, updateLoading } = this.props

        await this.fetchShifts(formData.offerId, this.state.isSkipValidation);

        updateLoading(false);
    }

    fetchShifts = async (offerId, isSkipValidation) => {
        await getMyShiftsToPropose(this.props.options, offerId, isSkipValidation)
        .then((shiftResponse) => {
            this.setState({ validProposalShifts: shiftResponse.data.shifts });
        })
        .catch((error) => {
            const message = aux.handleAPIErrors(error.response);
            this.handleSnackbar('error', message, true);
        });;
    };

    handleChangeIsSkipValidation = async (event) => {
        const isChecked = event.target.checked;
        this.setState({ isSkipValidation: isChecked });

        await this.fetchShifts(this.props.formData.offerId, isChecked);

        if (!isChecked) {
            this.props.updateProposalShiftsSelected([]);
        }
    };

    handleOpenDrawer = () => {
        this.setState({ isDrawerOpen: true });
    };

    handleCloseDrawer = () => {
        this.setState({ isDrawerOpen: false });
    };

    handleSnackbar = (type, message, openState) => {
        this.props.updateSnackbar({
            typeSnackbar: type,
            messageSnackbar: message,
            openSnackbar: openState,
        })
    }

    render() {
        const { updateSidePanelView, handlePreviousView, updateProposalShiftsSelected, mobileProposalShiftsSelected = [], classes, formData, updateProposalPartialDates, proposalPartialDates, storeData } = this.props
        const { validProposalShifts, isSkipValidation, isDrawerOpen } = this.state
        let formattedShifts = aux.formatShift(validProposalShifts);
        const isPartialEnabledInSetting = formData.managerSetting.isPartialShiftEnabled;
        const sliderPartialRequestWithLabelProps = {
            storeData,
            requestType: RequestTypes.shiftSwap,
            handleChange: (e, val, shifts, requestType) => handleChangeProposalPartial(updateProposalPartialDates, e, val, shifts, requestType),
            selectedPartial: proposalPartialDates.partialShiftLabel,
        }
        return (
            <React.Fragment>
                <div className={classes.viewContainer}>
                <Grid container justifyContent="flex-end">
                        {isPartialEnabledInSetting && (
                            <Grid item xs={12} container alignItems="center" justifyContent="flex-end" style={{ display: "flex", gap: "8px" }}>
                                <FormControlLabel
                                    label="Show All"
                                    labelPlacement="start"
                                    control={
                                        <Checkbox
                                            color="primary"
                                            checked={isSkipValidation}
                                            onChange={this.handleChangeIsSkipValidation}
                                        />
                                    }
                                />
                                <Tooltip title="Show all available shifts." arrow>
                                    <HelpIcon fontSize="small" style={{ cursor: "pointer", marginBottom: '8px' }} onClick={this.handleOpenDrawer} />
                                </Tooltip>
                            </Grid>)}                        <Grid item xs={12} style={{ maxHeight: 'calc(100vh - 126px)', overflow: 'auto' }}>
                            <ListSelect shiftsArray={_.sortBy(formattedShifts, ['fullTime'])} selection={mobileProposalShiftsSelected.map(x => x.id)}
                                handlerUpdateState={(update) => { updateProposalShiftsSelected(validProposalShifts.filter(shift => update.includes(shift.id))) }}
                                isPartialEnabledInSetting={isPartialEnabledInSetting} offeredShiftsCount={formData.shifts.length}
                                sliderPartialRequestWithLabelProps={sliderPartialRequestWithLabelProps}
                            />
                        </Grid>
                    </Grid>
                    <Drawer
                        anchor="bottom"
                        open={isDrawerOpen}
                        onClose={this.handleCloseDrawer}
                        classes={{ paper: classes.privateEmployeeWarningModal }}
                    >
                        <Typography style={{ padding: '5px' }} variant={'h5'} className={classes.viewHeader}>
                            Information
                        </Typography>
                        <Typography style={{ padding: '10px' }}>
                            Check to see all the available shifts without the rules being pre-validated. Upon selecting a full or a partial shift, the validation will be done when submitting. This might result in having to submit more than once if the validations fail due to a schedule rule. This is recommended for partial shift requests.
                        </Typography>
                    </Drawer>
                    <Grid container className={classes.bottomBar}>
                        <Grid item xs={6} style={{ padding: '5px' }}>
                            <Button fullWidth className={classes.secondaryButton} onClick={handlePreviousView}>
                                Back
                            </Button>
                        </Grid>
                        <Grid item xs={6} style={{ padding: '5px' }}>
                            <Button fullWidth className={classes.primaryButton} onClick={() => updateSidePanelView('Summary')}>
                                Next
                            </Button>
                        </Grid>
                    </Grid>
                </div>
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        storeData: state.data,
        mobileProposalShiftsSelected: state.mobileProposalShiftsSelected,
        dateRanges: state.dateRanges,
        formData: state.mobileOfferShiftForm,
        options: state.httpOptions,
        proposalPartialDates: state.proposalPartialDates,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        updateProposalShiftsSelected: payload => dispatch(updateProposalShiftsSelected(payload)),
        updateLoading: payload => dispatch(updateLoading(payload)),
        updateSnackbar: payload => dispatch(updateSnackbar(payload)),
        updateProposalPartialDates: payload => dispatch(updateProposalPartialDates(payload)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(EmployeeDashboardMobileSidePanelStyles)(ShiftsPicker));